export enum ChangeType {
  REMOVED,
  ADDED,
}
